import React from 'react';
import { EmptyState, Table } from '@opendate-app/setlist';
import TeamPagination from '../../TeamManager/components/TeamPagination';

// "Donations influenced by" — the soft credits a contact or organization has
// received on other donors' gifts. Rendered under the Donations tab on both
// detail pages; `softCreditsHook` is a useSoftCredits instance.
export default function SoftCreditsReceivedCard({ softCreditsHook, subjectLabel = 'this contact' }) {
  return (
    <div className="card mb-3">
      <div className="card-body p-0">
        <div className="border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
          <h2 className="h6 mb-0">Soft Credits</h2>
          <span className="text-muted small">
            Donations influenced by {subjectLabel}
            {softCreditsHook.total ? ` — ${softCreditsHook.total}` : ''}
          </span>
        </div>

        <Table
          columns={[
            { key: 'date', header: 'Date', render: (sc) => sc.date },
            { key: 'amount', header: 'Attributed', render: (sc) => sc.amount },
            { key: 'donation_amount', header: 'Donation', render: (sc) => sc.donation_amount },
            { key: 'donated_by', header: 'Donated By', primary: true, render: (sc) => sc.donated_by || '—' },
            { key: 'campaign', header: 'Campaign', render: (sc) => sc.campaign },
          ]}
          data={softCreditsHook.softCredits}
          getRowKey={(sc) => sc.id}
          loading={softCreditsHook.loading}
          loadingLabel="Loading soft credits..."
          error={softCreditsHook.error || null}
          empty={<EmptyState size="sm" title="No soft credits yet." />}
        />

        <TeamPagination
          currentPage={softCreditsHook.page}
          totalPages={softCreditsHook.totalPages}
          totalItems={softCreditsHook.totalEntries}
          pageSize={softCreditsHook.perPage}
          itemLabel="soft credits"
          onPageChange={(newPage) => {
            if (!softCreditsHook.loading && newPage >= 1 && newPage <= softCreditsHook.totalPages) {
              softCreditsHook.setPage(newPage);
            }
          }}
        />
      </div>
    </div>
  );
}
